/** @format */

import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

export default function Footer({ data, links, sitemap }) {
  return (
    <footer className="pt-5">
      <div className="tb-container">
        <div className="flex items-center justify-center">
          <p className="text-black text-base leading-[26px] font-semibold text-center">
            <a href={data?.tel1}>
              <span className="block">{data.phone1}</span>
            </a>
            <a href={data?.tel2}>
              <span className="text-[#323a44] block">{data.phone2}</span>
            </a>
            <br />
            <a href={`mailto:${data?.email}`}>
              <span className="text-[#323a44] block uppercase">
                {data.email}
              </span>
            </a>
          </p>
        </div>
        <br />
        <div className="hidden sm:flex sm:justify-between max-w-[912px] mx-auto flex-wrap px-5 sm:px-0">
          {links?.footerlogoSec.map((item, index) => {
            return (
              <a
                href={item.logoUrl}
                target="_blank"
                rel="noreferrer"
                key={index}
                aria-label={item?.brandName}
              >
                {item.logoType === "img" ? (
                  <div className="w-[90px] h-[90px]">
                    <GatsbyImage
                      image={item?.logo?.asset?.gatsbyImageData}
                      alt={`footer-images-${index}`}
                      imgStyle={{ objectFit: "contain" }}
                    />
                  </div>
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: item.svgs }} />
                )}
              </a>
            );
          })}
        </div>
      </div>
      <br />
      <br />
      <div
        className="w-full"
        style={{
          backgroundImage: `linear-gradient(
      to bottom,
      rgba(192, 192, 192, 0.9),
      rgba(121, 121, 121, 0.9)
    ),
    url(${data?.footerbg?.asset?.url})`,
          backgroundSize: "cover",
        }}
      >
        <p className="text-black text-base py-5 leading-[26px] uppercase font-semibold text-center">
          {data.cc}
        </p>
        {sitemap && (
          <Link to="/sitemap">
            <p className="text-black cursor-pointer text-base py-5 leading-[26px] font-semibold text-center">
              SITE MAP
            </p>
          </Link>
        )}
      </div>
    </footer>
  );
}
